import React, { useState, useEffect } from "react";
import { IonAvatar } from "@ionic/react";
import { User } from "../@types/user";
import api from "../utils/api";
import userAvatar from '../assets/user.png';



const UserAvatar: React.FC<{ user?: User }> = ({ user = {} }) => {
  const [avatarSrc, setAvatarSrc] = useState(userAvatar);

  useEffect(() => {
    const fetchAvatar = async () => {
      if (user?.profilePicture) {
        try {
          const token = localStorage.getItem('token');
          const profilePictureId = user?.profilePicture?.id || user?.profilePicture;
          const response = await fetch(`${api.baseURL}archive/${profilePictureId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });

          if (response.ok) {
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            setAvatarSrc(url);
          } else {
            console.error('Error fetching avatar:', response.statusText);
          }
        } catch (error) {
          console.error('Fetch error:', error);
        }
      }
    };

    fetchAvatar();
  }, [user]);

  return (
    <IonAvatar slot="start">
      <img
        src={avatarSrc}
        alt="User Avatar"
        width="100"
        height="100"
      />
    </IonAvatar>
  );
};

export default UserAvatar;
